import useMasterProducts from 'hooks/useMasterProducts';
import { unmaskPrice } from 'screens/Recommendations/helpers/dataHelpers';
import { Maths } from 'helpers/maths';

const usePlanProducts = (formikContext = {}) => {
  const { appliedAreaCalculation } = useMasterProducts();
  const { setFieldValue, values } = formikContext;

  const recalculateProducts = async (planProductEntries, areaValue) => {
    const promiseProductsUpdated = (planProductEntries ?? []).map(
      async product => {
        const mappedProduct = await appliedAreaCalculation(product, areaValue);

        return mappedProduct;
      }
    );

    const productsUpdated = await Promise.all(promiseProductsUpdated);

    return productsUpdated;
  };

  const recalculateCosts = estimatedAreaValue => {
    if (setFieldValue && values) {
      if (values.fixedCost.landRent_PerAc) {
        setFieldValue(
          'fixedCost.landRent',
          Maths.multiplyRound(
            Number(unmaskPrice(values.fixedCost.landRent_PerAc)),
            Number(estimatedAreaValue),
            2
          )
        );
      }

      if (values.fixedCost.repairs_PerAc) {
        setFieldValue(
          'fixedCost.repairs',
          Maths.multiplyRound(
            Number(unmaskPrice(values.fixedCost.repairs_PerAc)),
            Number(estimatedAreaValue),
            2
          )
        );
      }

      if (values.fixedCost.returnToMgt_PerAc) {
        setFieldValue(
          'fixedCost.returnToMgt',
          Maths.multiplyRound(
            Number(unmaskPrice(values.fixedCost.returnToMgt_PerAc)),
            Number(estimatedAreaValue),
            2
          )
        );
      }

      if (values.fixedCost.equipment_PerAc) {
        setFieldValue(
          'fixedCost.equipment',
          Maths.multiplyRound(
            Number(unmaskPrice(values.fixedCost.equipment_PerAc)),
            Number(estimatedAreaValue),
            2
          )
        );
      }

      if (values.fixedCost.taxes_PerAc) {
        setFieldValue(
          'fixedCost.taxes',
          Maths.multiplyRound(
            Number(unmaskPrice(values.fixedCost.taxes_PerAc)),
            Number(estimatedAreaValue),
            2
          )
        );
      }

      if (values.fixedCost.labor_PerAc) {
        setFieldValue(
          'fixedCost.labor',
          Maths.multiplyRound(
            Number(unmaskPrice(values.fixedCost.labor_PerAc)),
            Number(estimatedAreaValue),
            2
          )
        );
      }

      if (values.fixedCost.insurance_PerAc) {
        setFieldValue(
          'fixedCost.insurance',
          Maths.multiplyRound(
            Number(unmaskPrice(values.fixedCost.insurance_PerAc)),
            Number(estimatedAreaValue),
            2
          )
        );
      }

      if (values.projectedRevenue.fsaPaymentPerAc) {
        setFieldValue(
          'projectedRevenue.fsaPayment',
          Number.parseFloat(
            Number(unmaskPrice(values.projectedRevenue.fsaPaymentPerAc)) *
              Number(estimatedAreaValue)
          )
        );
      }

      if (values.projectedRevenue.yieldTotal) {
        setFieldValue(
          'projectedRevenue.yieldTotal',
          Number.parseFloat(
            Number(unmaskPrice(values.projectedRevenue.pricePerUnit)) *
              Number(values.projectedRevenue.yieldPerArea) *
              Number(estimatedAreaValue)
          )
        );
      }
    }
  };

  return { recalculateProducts, recalculateCosts };
};

export default usePlanProducts;
